// the only place where we need to import useDispatch and useSelector
// eslint-disable-next-line no-restricted-imports
import { useDispatch, useSelector, useStore } from "react-redux"

import type { AppDispatch, AppStore, RootState } from "./redux-store"

export const useAppDispatch = useDispatch.withTypes<AppDispatch>()
export const useAppSelector = useSelector.withTypes<RootState>()
export const useAppStore = useStore.withTypes<AppStore>()
